// extracted by mini-css-extract-plugin
module.exports = {"messages":"Messages_messages__2JefQ","empty":"Messages_empty__2Chuk"};